import { render } from "./PersetujuanFisik.vue?vue&type=template&id=6d93bdd4&scoped=true"
import script from "./PersetujuanFisik.vue?vue&type=script&lang=js"
export * from "./PersetujuanFisik.vue?vue&type=script&lang=js"

import "./PersetujuanFisik.vue?vue&type=style&index=0&id=6d93bdd4&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d93bdd4"]])

export default __exports__